module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item13-acdc07f98440edfc429b4b5f7920ced4.svg";